import { createSlice } from '@reduxjs/toolkit';
import {
  validateTransferAggregatePartnerAsync,
  validateTransferAggregatePartnerExtraReducers,
} from './serviceActions/validateTransferAggregatePartnerAsync';
import {
  submitTransferAggregatePartnerAsync,
  submitTransferAggregatePartnerExtraReducers,
} from './serviceActions/submitTransferAggregatePartnerAsync';

const initialState = {
  transferAggregatePartnerState: {
    isAggregate: false,
    inProgress: false,
    isSubmitting: false,
    errorMessage: null,
    results: null,
    submitSuccess: false,
  },
};

const transferAggregatePartnerSlice = createSlice({
  name: 'TransferAggregatePartner',
  initialState,
  reducers: {
    resetTransferAggregatePartner(state) {
      state.transferAggregatePartnerState = initialState.transferAggregatePartnerState;
    },
  },
  extraReducers: {
    ...validateTransferAggregatePartnerExtraReducers,
    ...submitTransferAggregatePartnerExtraReducers,
  },
});

export { validateTransferAggregatePartnerAsync, submitTransferAggregatePartnerAsync };
export const { resetTransferAggregatePartner } = transferAggregatePartnerSlice.actions;
export default transferAggregatePartnerSlice.reducer;
